import { render, staticRenderFns } from "./taili_2026_doc.vue?vue&type=template&id=478cce22&scoped=true"
import script from "./taili_2026_doc.vue?vue&type=script&lang=js"
export * from "./taili_2026_doc.vue?vue&type=script&lang=js"
import style0 from "./taili_2026_doc.vue?vue&type=style&index=0&id=478cce22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478cce22",
  null
  
)

export default component.exports